import {useNavigate} from "react-router-dom";
import {useContext} from "react";
import {ChangesContext, ToastContext} from "../Contexts";
import {
    TextFilterRequest, TextUpdateRequest,
    ToastFailureMessage,
    ToastSuccessMessage
} from "../Models/Models";
import HttpRepository from "./HttpRepository";

export function TextService() {
    const navigate = useNavigate()
    let {setToast}: any = useContext(ToastContext);
    let { setHasChanges } : any = useContext(ChangesContext);

    async function filterTexts(request: TextFilterRequest): Promise<any> {
        try {
            return (await HttpRepository.filterTexts(request)).data;
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
        }
    }

    async function getText(id: number): Promise<any> {
        try {
            return (await HttpRepository.getText(id)).data;
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
        }
    }

    async function updateText(request: TextUpdateRequest, pageId: number | null): Promise<void> {
        try {
            await HttpRepository.updateText(request);
            setHasChanges(true);
        } catch (error) {
            setToast({message: ToastFailureMessage.changesNotSaved});
            return;
        }

        setToast({message: ToastSuccessMessage.dataSaved});
        navigate(pageId != null ? `/text/table/${pageId}` : '/text/table');
    }

    return {getText, filterTexts, updateText}
}